/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import {
    object, string, shape, arrayOf, number, bool, func, array,
} from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import ReactMarkDown from 'react-markdown';
import RadioOfferProductList from './RadioOfferProductList';
import RailMenuTabletContainer from '../../GraphqlCategoryPage/Partials/RailMenuTabletContainer/RailMenuTabletContainer';

const styles = (theme) => ({
    container: {
        maxWidth: '100%',
        padding: '10px',
    },
    heading: {
        margin: '10px 0 15px',
        padding: '0 10px',
        fontSize: '18px',
        fontWeight: '400',
        lineHeight: '3.05',
        backgroundColor: theme.palette.grey9,
    },

    featureBlock: {
        width: '47.5%',
        height: '100%',
        margin: '0 auto',
    },
    bannerImage: {
        maxWidth: '100%',
    },
    bottomBannerContainerMobile: {
        maxWidth: '768px',
        width: '100%',
    },
});

const RadioOfferResultsMobilePage = ({
    nameFeature,
    productFeature,
    classes,
    productFavorites,
    nameFavorite,
    bannerImage,
    title,
    bestSeller,
    loadComponent,
    copy,
    blocksData,
    bottomBanner,
    numOfProduct,
    isMobile,
}) => (
    <div>
        <Grid container className={classes.container}>

            {bannerImage && <img className={classes.bannerImage} src={`https://cdn1.1800flowers.com/wcsstore/Flowers/images/banners/radio/personality/${bannerImage}`} alt={title} aria-hidden />}
            {copy && <ReactMarkDown source={copy} escapeHtml={false} />}

            {nameFeature && <Grid item xs={12}><h3 className={`${classes.heading}`}>{nameFeature}</h3></Grid>}
            <Grid item xs={12}>
                { (productFeature.length > 0
                            && loadComponent)
                             && (
                                 <Grid item className={`${classes.featureBlock}`}>
                                     <RadioOfferProductList product={productFeature[0]} />
                                 </Grid>
                             )}
            </Grid>
            <Grid item xs={12}><h3 className={`${classes.heading}`}>{nameFavorite}</h3></Grid>
            {(productFavorites.length > 0 && loadComponent) && productFavorites.map((product, index) => {
                if (index <= 2) {
                    return (
                        <Grid item xs={numOfProduct === 2 ? 6 : 12} key={product.name}>
                            <Grid item>
                                <RadioOfferProductList product={product} />
                            </Grid>
                        </Grid>
                    );
                }
                return null;
            })}
            { (bestSeller?.length > 0 && loadComponent) && bestSeller.map((list) => (
                <Grid item xs={numOfProduct === 2 ? 6 : 12} key={list.name}>
                    <Grid item>
                        <RadioOfferProductList product={list} />
                    </Grid>
                </Grid>
            ))}
            {blocksData?.page_blocks?.map((block) => bottomBanner(block))}
        </Grid>
        <RailMenuTabletContainer railMenuData={blocksData} isMobile={isMobile} />
    </div>
);

RadioOfferResultsMobilePage.propTypes = {
    nameFeature: string.isRequired,
    nameFavorite: string,
    bannerImage: string.isRequired,
    title: string.isRequired,
    productFeature: arrayOf(
        shape({
            prices: arrayOf(
                shape({
                    __typename: string.isRequired,
                    currency: string.isRequired,
                    type: string.isRequired,
                    value: number.isRequired,
                }).isRequired,
            ).isRequired,
            skuPriceRange: shape({
                sale: arrayOf(
                    shape({
                        value: number.isRequired,
                    }),
                ),
                retail: arrayOf(
                    shape({
                        value: number.isRequired,
                    }),
                ),
            }).isRequired,
            seo: shape({
                url: string.isRequired,
            }).isRequired,
            image: shape({
                name: string.isRequired,
                path: string.isRequired,
            }),
            sale: string,
            isPassportEligible: bool.isRequired,
        }),
    ).isRequired,
    bestSeller: arrayOf(
        shape({
            prices: arrayOf(
                shape({
                    __typename: string.isRequired,
                    currency: string.isRequired,
                    type: string.isRequired,
                    value: number.isRequired,
                }).isRequired,
            ).isRequired,
            skuPriceRange: shape({
                sale: arrayOf(
                    shape({
                        value: number.isRequired,
                    }),
                ),
                retail: arrayOf(
                    shape({
                        value: number.isRequired,
                    }),
                ),
            }).isRequired,
            seo: shape({
                url: string.isRequired,
            }).isRequired,
            image: shape({
                name: string.isRequired,
                path: string.isRequired,
            }),
            sale: string,
            isPassportEligible: bool.isRequired,
        }),
    ).isRequired,
    productFavorites: arrayOf(
        shape({
            prices: arrayOf(
                shape({
                    __typename: string.isRequired,
                    currency: string.isRequired,
                    type: string.isRequired,
                    value: number.isRequired,
                }).isRequired,
            ).isRequired,
            skuPriceRange: shape({
                sale: arrayOf(
                    shape({
                        value: number.isRequired,
                    }),
                ),
                retail: arrayOf(
                    shape({
                        value: number.isRequired,
                    }),
                ),
            }).isRequired,
            seo: shape({
                url: string.isRequired,
            }).isRequired,
            image: shape({
                name: string.isRequired,
                path: string.isRequired,
            }),
            sale: string,
            isPassportEligible: bool.isRequired,
        }),
    ).isRequired,
    classes: object.isRequired,
    loadComponent: bool.isRequired,
    copy: string,
    blocksData: shape({
        pageBlocks: array,
    }),
    isMobile: bool.isRequired,
    bottomBanner: func,
    numOfProduct: number,
};

RadioOfferResultsMobilePage.defaultProps = {
    copy: '',
    blocksData: {
        page_blocks: [],
    },
    bottomBanner: () => {},
    nameFavorite: '',
    numOfProduct: 2,
};

export default withStyles(styles)(RadioOfferResultsMobilePage);
